export class Replay {
    constructor(
        public id:number,
        public name: string,
        public subject: any,
        public reply: any,
        public status: boolean,
        public header_footer_included: boolean = false
      ) {  }

}